(ns ui.editor2.design
  "This ns contains the panel that only shows the render of the design.
   It is used in the editor together with many other UI elements as well as
   isolated on the ui.editor2.recorder page to take a screenshot without any
   other UI elements."
  (:require [clojure.string :as str]
            [ui.editor2.common :as common]
            [ui.editor2.defaults :as defaults]
            [ui.editor2.extension-points :as extension-points]))

(defn transform-str
  [transform]
  (str
    (when-let [translate (:translate transform)]
      (str "translate("
           (str/join ", "
                     (map (fn [v]
                            (str v
                                 "px"))
                          ;; Only taking x and y, otherwise transform3d must be
                          ;; used:
                          (take 2
                                translate)))
           ")"))
    " "
    (when-let [scale (:scale transform)]
      (str "scale("
           (str/join ", "
                     (take 2 scale))
           ")"))
    (when-let [rotate (:rotate transform)]
      (str " rotate("
           rotate
           "deg)"))))

(defn panel
  [state]
  [:div#composition-design
   {:style {:position "relative"
            :width (str (:design/width defaults/defaults)
                        "px")
            :height (str (:design/height defaults/defaults)
                         "px")
            :background-color (or (:slide/background-color
                                    (common/get-current-slide state))
                                  "#000000")
            ;; Text without a colour mark inherits this colour. In the
            ;; editor it used to inherit the `text-white` of the editor
            ;; layout, but on the recorder page of `apps/renderer6` the
            ;; browser's default black, so the posted Story differed:
            :color "white"}
    :class [(when (:screenshot-ready (:editor2 state))
              ;; Used for `apps/renderer6` to signal
              ;; `app.screenshot.capture` that it can take a screenshot of
              ;; the clip:
              "editor2-screenshot-ready")]
    :replicant/on-mount (fn [{:keys [replicant/node]}]
                          (.scrollIntoView node
                                           #js {:block "center"}))}

   (when-not (get-in state [:editor2 :hide-instagram-overlay?])
     [:img {:src "/img/editor2-overlay-instagram.svg"
            :class ["absolute"
                    "inset-0"
                    "z-20"
                    "pointer-events-none"]
            :style {:width "100%" :height "100%"}}])
   [:div
    (let [clips (common/get-all-clips state)
          playhead-position (get-in state
                                    [:editor2
                                     :playhead-position])]
      (for [clip clips]
        (let [asset (:clip/asset clip)
              invisible? (:invisible (:asset/data asset))
              selected-uuids (common/selected-clip-uuids state)
              ;; Treat anything in the multi-selection as "selected" so that
              ;; Moveable receives the click (and can apply shift-toggle) for
              ;; clips already in the selection. Single-select keeps the
              ;; existing fast-path where the design layer handles the click.
              selected (contains? selected-uuids (:clip/uuid clip))]
          [:div
           {:replicant/key (str (:clip/uuid clip))
            :data-uuid (str (:clip/uuid clip))
            :style (let [transform (some-> clip
                                           (:clip/transform)
                                           (transform-str))]
                     (merge
                       {:position "absolute"
                        :width (str (:asset/width asset) "px")
                        :height (str (:asset/height asset) "px")
                        :top "0px"
                        :left "0px"
                        :box-sizing "border-box"
                        :--transform transform
                        :transform transform
                        :transform-origin "top left"
                        }
                       (when invisible?
                         {:outline "7px dashed #eeeeee"
                          :background-color "#00000040"
                          :outline-offset "-7px"
                          :border-radius "10px"})
                       (when (and (>= (count selected-uuids) 2)
                                  (contains? selected-uuids (:clip/uuid clip)))
                         ;; Per-clip outline only in multi-select. Single
                         ;; select already gets Moveable's handles.
                         {:outline "1px solid #4f9aff"
                          :outline-offset "0px"})
                       (when-not (<= (:clip/start clip)
                                     playhead-position
                                     (:clip/end clip))
                         {:display "none"})))
            ;; Rendered images (stickers, photos, GIFs) must not start a
            ;; native browser drag. Dropping that drag back onto the editor
            ;; turns the rendered clip into a duplicate PNG upload.
            :on (cond-> {:dragstart [[:js/prevent-default]
                                      [:js/stop-propagation]]}
                  (not selected)
                  (assoc :mousedown [[:editor2/click-clip
                                      (:clip/uuid clip)]]))}
           (extension-points/composition-asset
             {:clip clip
              :state state})])))]
   (for [kind (keys (methods extension-points/composition-overlay))]
     (extension-points/composition-overlay {:state state}
                                           kind))])
